(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class MobileMenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.hamburgerWrapper = null;
    this.headerMenuDrawer = null;
    this.mediaQuery = window.matchMedia('(min-width: 1025px)');
    this.boundHandleMediaChange = this.handleMediaChange.bind(this);
  }

  connectedCallback() {
    this.childlinkLinks = this.querySelectorAll('[data-nav-childlink-link]');
    this.childlinkLinksBack = this.querySelectorAll('[data-mobile-childlink-back]');
    
    this.initChildLinksClick();

    this.hamburgerWrapper = this.querySelector('[data-hamburger-Wrapper]');
    this.headerMenuDrawer = document.querySelector('hamburger-drawer-tabs');

    this.closeButton = this.querySelector('[data-offcanvas-close]');
    this.headerMenuDrawerTrigger = document.querySelector('[data-mobile-drawer-button]');

    if (this.headerMenuDrawerTrigger) {
      this.headerMenuDrawerTrigger.addEventListener('click', () => this.openDrawer());
    }
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.closeDrawer());
    }

    if (this.hamburgerWrapper && this.headerMenuDrawer) {
      this.initHamburger();
    }

    // ✅ Listen for desktop/mobile switch
    this.mediaQuery.addEventListener('change', this.boundHandleMediaChange);
    this.handleMediaChange(this.mediaQuery);

    this.hamburgerDrawer();
    if (Shopify.designMode) {
      this.observeDesignMode();
    }
  }
  observeDesignMode() {
  
    this.addEventListener('shopify:section:load', this.showHamburger);
    this.addEventListener('shopify:section:unload', this.hideHamburger);
    this.addEventListener('shopify:section:select', this.showHamburger);
    this.addEventListener('shopify:section:deselect', this.hideHamburger);
  }

  showHamburger = () => {
    this.toggleHamburger(false);

  };

  hideHamburger = () => {
    this.toggleHamburger(true);

  };
  toggleHamburger(hide = true) {
    const nav = document.querySelector('[data-hamburger-nav]');
    const button = document.querySelector('[data-hamburger-button-wrapper]');
    if (!nav || !button) return;

    nav.classList.toggle('hidden', hide);
    button.classList.toggle('hidden', hide);
  }

  disconnectedCallback() {
    this.mediaQuery.removeEventListener('change', this.boundHandleMediaChange);
  }
  hamburgerDrawer() {
    this.querySelectorAll('[data-main-hamburger]').forEach(tabsContainer => {
      const tabButtons = tabsContainer.querySelectorAll('[data-link-hamburger]');
      const tabContents = tabsContainer.querySelectorAll('[data-block-hamburger]');

      const activateTab = (button) => {
        const targetId = button.getAttribute('data-tab');
        const targetContent = tabsContainer.querySelector(`#${targetId}`);
        if (!targetContent) return;

        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(content => {
          content.classList.remove('active');
          // If the element is empty (no child nodes or text)
          const isEmpty = !content.innerHTML.trim();
          if (isEmpty) {
            content.classList.add('no-subdata');
          } else {
            content.classList.remove('no-subdata'); // Optional: clean up if previously added
          }
        });


        button.classList.add('active');
        targetContent.classList.add('active');
      };

      tabButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          activateTab(button);
        });

        button.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activateTab(button);
          }
        });
        // button.addEventListener('focus', () => {
        //   activateTab(button);
        // });
      });
    });

    
    // Global click handlers
    this.addEventListener('click', (e) => {
      const navLink = e.target.closest('[data-nav-hamburger-link]');
      const backButton = e.target.closest('[data-hamburger-back]');

      if (navLink) {
        const mainParent = navLink.closest('[data-hamburger-nav]');
        const parent = navLink.closest('[data-hamburger-megamenu-item]');
        const siblings = parent?.parentElement?.querySelectorAll('[data-hamburger-megamenu-item]');
        if (mainParent && parent && siblings) {
          mainParent.classList.add('hamburger-megamenu-menus-open');
          siblings.forEach(item => item.classList.remove('active'));
          parent.classList.add('active');
          const focusElement = parent.querySelector('.hamburger-megamenus-menuswrap');
          // if (focusElement) {
          //   trapFocus(focusElement);
          // }
        }
      }

      if (backButton) {
        const mainParent = backButton.closest('[data-hamburger-nav]');
        document.querySelectorAll('[data-hamburger-megamenu-item].active').forEach(item => {
          item.classList.remove('active');
        });
        if (mainParent) {
          mainParent.classList.remove('hamburger-megamenu-menus-open');
        }
      }
    });
  }

  openDrawer() {
    this.classList.add('mobile-menu-open');
    document.body.classList.add('overflow-hidden');
  }

  closeDrawer() {
    this.classList.remove('mobile-menu-open');
    document.body.classList.remove('overflow-hidden');
  }

  handleMediaChange(e) {
    if (e.matches) {
      // >=1025px desktop
      this.closeDrawer();
    } else {
      // <1025px mobile
      if (this.hamburgerWrapper && this.headerMenuDrawer) {
        this.initHamburger();
      }
    }
  }

  initChildLinksClick() {
    this.childlinkLinks.forEach(childlink => {
      childlink.addEventListener('click', (e) => {
        e.preventDefault();
        const clickedMenu = childlink.closest('[data-child-menu]');
        if (clickedMenu) clickedMenu.classList.toggle('active-submenu');
      });
    });

    this.childlinkLinksBack.forEach(childlinkBack => {
      childlinkBack.addEventListener('click', (e) => {
        e.preventDefault();
        const clickedMenu = childlinkBack.closest('[data-child-menu]');
        if (clickedMenu) clickedMenu.classList.remove('active-submenu');
      });
    });
  }

  initHamburger() {
    const checkVisibility = this.headerMenuDrawer.getAttribute('data-visibility-on');
    if (checkVisibility === 'desktop') return;

    const template = this.headerMenuDrawer.querySelector('template');
    if (!template) return;

    this.hamburgerWrapper.innerHTML = '';
    const clone = template.content.cloneNode(true);

    // const navWithAttr = clone.querySelector('[data-hamburger-nav]');
    // if (navWithAttr) navWithAttr.removeAttribute('data-hamburger-nav');

    // const navWithColor = clone.querySelector('[data-color-scheme]');
    // if (navWithColor) {
    //   navWithColor.classList.remove('hamburger-nav');
    //   navWithColor.classList.add('hamburger-mobilenav');
    //   const colorClass = navWithColor.getAttribute('data-color-scheme');
    //   if (colorClass) navWithColor.classList.remove(colorClass);
    // }

    this.hamburgerWrapper.appendChild(clone);
    this.hamburgerWrapper.classList.remove('hidden');

    // Add submenu toggles for hamburger menu
    this.hamburgerChildLink = this.querySelectorAll('[data-nav-hamburger-link]');
    this.hamburgerChildLinkBack = this.querySelectorAll('[data-hamburger-back]');

    if (this.hamburgerChildLink) {
      this.hamburgerChildLink.forEach(childlink => {
        childlink.addEventListener('click', (e) => {
          // e.preventDefault();
          const mainParent = childlink.closest('.hamburger-mobilenav');
          const parent = childlink.closest('[data-hamburger-megamenu-item]');
          const siblings = parent?.parentElement?.querySelectorAll('[data-hamburger-megamenu-item]');
          if (mainParent && parent && siblings) {
            mainParent.classList.add('hamburger-megamenu-menus-open');
            siblings.forEach(item => item.classList.remove('active'));
            parent.classList.add('active');
          }
        });
      });
    }

    if (this.hamburgerChildLinkBack) {
      this.hamburgerChildLinkBack.forEach(childlinkBack => {
        childlinkBack.addEventListener('click', (e) => {
          e.preventDefault();
          const mainParent = childlinkBack.closest('.hamburger-mobilenav');
          document.querySelectorAll('[data-hamburger-megamenu-item].active').forEach(item => {
            item.classList.remove('active');
          });
          if (mainParent) {
            mainParent.classList.remove('hamburger-megamenu-menus-open');
          }
        });
      });
    }

    this.hamburgerDrawer();
  }
}

customElements.define('mobile-menu-drawer', MobileMenuDrawer);


class StickyHeader extends HTMLElement {
  constructor() {
    super();
    

  } 

  connectedCallback() {
    this.header = document.querySelector('.header-section');
     this.setHeaderHeight();
    if (!this.getAttribute('data-sticky-type')){
      document.body.classList.add('sticky-header-none');
      return;
    } 
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';

    this.headerBounds = {};

   

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    window.addEventListener('resize', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.classList.add('header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    // this.headerNavigation();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.classList.add('transparent-none');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.classList.add('transparent-none');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.classList.remove('transparent-none');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.classList.add('header-hidden', 'header-sticky');
    document.body.classList.add('header-ishidden');
    // this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.classList.add('header-sticky', 'animate');
    this.classList.remove('header-hidden');
    document.body.classList.remove('header-ishidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.classList.remove('header-hidden', 'header-sticky', 'animate');
    document.body.classList.remove('header-ishidden');
  }


  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    // this.searchModal.close(false);
  }

}

customElements.define('sticky-header', StickyHeader);





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-blocks"] && !Shopify.designMode) return;
  try {
    
  class DotsAnimator extends HTMLElement {
    constructor() {
      super();
      this.config = {
        sx: 2,
        sy: 1.5,
        tx: 0,
        ty: 0,
      };
      this.targets = [
        { sx: [0.385, 1.53], sy: [0.9, 0.9], tx: [-30.72, 26.64], ty: [-5, 0] },
        { sx: [0.67, 1.238], sy: [0.9, 0.9], tx: [-63.76, 61.68], ty: [-5, 0] },
        { sx: [0.96, 0.96], sy: [0.9, 0.9], tx: [-74.22, 74.22], ty: [-5, 0] },
        { sx: [1.238, 0.67], sy: [0.9, 0.9], tx: [-61.68, 63.76], ty: [-5, 0] },
        { sx: [1.53, 0.385], sy: [0.9, 0.9], tx: [-26.64, 30.72], ty: [-5, 0] },
      ];
      this.easingFactor = 8;
      this.mouse = [0, 0];
      this.current = { el: null, id: null };
      this.state = {};
      this.hasAnimatedId = null; // intersection active ellipse id
    }

    connectedCallback() {
      this.init();
      document.addEventListener('mousemove', this.onMouseMove.bind(this));
      document.addEventListener('mouseover', this.onMouseOver.bind(this));
      document.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.animate();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    init() {
      const elements = this.querySelectorAll('[data-elipse-animate]');
      elements.forEach((el, i) => {
        const id = `mask${i}`;
        const svg = this.createSVG(id);
        el.appendChild(svg);
        this.state[id] = {
          container: el,
          svg: svg,
          actual: this.initialState(),
          faded: this.initialState(),
        };

        // Reset current hover on mouse leave from element
        el.addEventListener('mouseleave', () => {
          if (this.current.el === el) {
            this.resetCurrent();
            this.current.el = null;
            this.current.id = null;
          }
        });
      });

      // Intersection observer to track viewport entry/exit
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const el = entry.target;
            const svg = el.querySelector('svg');
            if (!svg) return;
            const id = svg.id;

            if (entry.isIntersecting) {
              // Only activate if no other intersection active
              if (!this.hasAnimatedId) {
                this.hasAnimatedId = id;
                this.activateEllipse(id);
              }
            } else if (this.hasAnimatedId === id) {
              // Smooth reset when element leaves viewport
              this.resetEllipse(id);
              this.hasAnimatedId = null;
            }
          });
        },
        { threshold: 0.5 }
      );

      elements.forEach((el) => this.observer.observe(el));
    }

    onMouseMove(e) {
      this.mouse = [e.clientX || this.mouse[0], e.clientY || this.mouse[1]];

      if (this.current.el) {
        const rect = this.current.el.getBoundingClientRect();
        const progress = this.ease(Math.abs((this.mouse[0] - rect.left) / this.current.el.offsetWidth));

        const target = this.state[this.current.id];
        for (let i = 0; i < target.actual.length; i++) {
          const shape = target.actual[i];
          const t = this.targets[i];
          shape.sx = t.sx[0] + (t.sx[1] - t.sx[0]) * progress;
          shape.sy = t.sy[0];
          shape.tx = t.tx[0] + (t.tx[1] - t.tx[0]) * progress;
          shape.ty = t.ty[0];
        }
      }
    }

    onMouseOver(e) {
      const dot = e.target.closest('[data-elipse-animate]');
      if (!dot) {
        this.resetCurrent();
        this.current.el = null;
        this.current.id = null;
        return;
      }

      const svg = dot.querySelector('svg');
      const newId = svg ? svg.id : null;

      // Reset viewport active ellipse if different from hovered
      if (this.hasAnimatedId && this.hasAnimatedId !== newId) {
        this.resetEllipse(this.hasAnimatedId);
        this.hasAnimatedId = null;
      }

      // Reset previous hover ellipse if different from new hover
      if (this.current.el && this.current.el !== dot) {
        this.resetCurrent();
      }

      this.current.el = dot;
      this.current.id = newId;
      document.dispatchEvent(new Event('mousemove')); // update animation immediately
    }

    onMouseLeave(e) {
      // Smoothly reset the current hovered ellipse
      this.resetCurrent();
      this.current.el = null;
      this.current.id = null;
    }

    animate() {
      for (const id in this.state) {
        const { svg, actual, faded } = this.state[id];
        for (let i = 0; i < faded.length; i++) {
          const target = actual[i];
          const current = faded[i];
          current.sx += (target.sx - current.sx) / this.easingFactor;
          current.sy += (target.sy - current.sy) / this.easingFactor;
          current.tx += (target.tx - current.tx) / this.easingFactor;
          current.ty += (target.ty - current.ty) / this.easingFactor;
          if (svg.children[i + 1]) {
            svg.children[
              i + 1
            ].style.transform = `translate(${current.tx}%, ${current.ty}%) scale(${current.sx}, ${current.sy})`;
          }
        }
      }
      requestAnimationFrame(this.animate.bind(this));
    }

    ease(t) {
      return (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2);
    }

    initialState() {
      return Array(5)
        .fill()
        .map(() => ({
          sx: this.config.sx,
          sy: this.config.sy,
          tx: this.config.tx,
          ty: this.config.ty,
        }));
    }

    activateEllipse(id) {
      const target = this.state[id];
      if (!target) return;
      for (let i = 0; i < target.actual.length; i++) {
        const shape = target.actual[i];
        const t = this.targets[i];
        shape.sx = t.sx[1];
        shape.sy = t.sy[0];
        shape.tx = t.tx[1];
        shape.ty = t.ty[0];
      }
    }

    resetEllipse(id) {
      if (!id || !this.state[id]) return;
      const target = this.state[id];
      for (let i = 0; i < target.actual.length; i++) {
        target.actual[i].sx = this.config.sx;
        target.actual[i].sy = this.config.sy;
        target.actual[i].tx = this.config.tx;
        target.actual[i].ty = this.config.ty;
      }
    }

    resetCurrent() {
      if (!this.current.id) return;
      this.resetEllipse(this.current.id);
    }

    createSVG(id) {
      const svg = this.createSVGElement('svg', {
        viewBox: '0 0 100 100',
        preserveAspectRatio: 'none',
        id: id,
        class: 'mask',
      });

      svg.appendChild(
        this.createSVGElement('rect', {
          width: '100%',
          height: '100%',
          fill: 'transparent',
        })
      );

      const positions = [13.75, 32, 50, 68, 86];
      positions.forEach((cx) => {
        const ellipse = this.createSVGElement('ellipse', {
          cx: cx,
          cy: '51',
          rx: '12.5',
          ry: '50',
          fill: 'black',
        });
        ellipse.style.transform = `translate(${this.config.tx}%, ${this.config.ty}%) scale(${this.config.sx}, ${this.config.sy})`;
        svg.appendChild(ellipse);
      });

      return svg;
    }

    createSVGElement(tag, attrs) {
      const el = document.createElementNS('http://www.w3.org/2000/svg', tag);
      for (let attr in attrs) {
        el.setAttribute(attr, attrs[attr]);
      }
      return el;
    }
  }

  customElements.define('xs-elipse-animator', DotsAnimator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  class MainPassword extends HTMLElement {
    constructor() {
      super();
      this.passwordButton = document.querySelector('[data-password]');
      this.passwordDrawer = document.querySelector('[data-offcanvas-password]');
    }
    connectedCallback() {
      if (this.passwordButton) {
        this.passwordButton.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            this.open();
          }.bind(this)
        );
      }
      this.setupCloseListeners();
    }
    open() {
      this.passwordDrawer.classList.add('offcanvas-open');
      document.body.classList.add('overflow-hidden');
      setTimeout(() => {
        this.trapFocus(this.passwordDrawer);
      }, 500);
    }
    setupCloseListeners() {
      const closeButtons = [
        document.querySelector('[data-offcanvas-close]'),
        document.querySelector('[offcanvas-close]'),
      ];

      closeButtons.forEach((btn) => {
        if (btn) {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
          });
        }
      });
    }
    close() {
      this.passwordDrawer.classList.remove('offcanvas-open');
      document.body.classList.remove('overflow-hidden');
    }
    trapFocus(container) {
      const focusableSelectors = [
        'a[href]',
        'button:not([disabled])',
        'textarea:not([disabled])',
        'input:not([type="hidden"])',
        'select:not([disabled])',
        'summary',
        '[tabindex]:not([tabindex="-1"])',
      ];

      const isVisible = (el) => {
        if (!el) return false;

        // Walk up all parents
        let node = el;
        while (node && node !== document.body) {
          const style = window.getComputedStyle(node);
          if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0' || node.hidden) {
            return false;
          }
          node = node.parentElement;
        }
        return true;
      };
      const focusableEls = Array.from(container.querySelectorAll(focusableSelectors.join(','))).filter(isVisible);
      const firstEl = focusableEls[0];
      const lastEl = focusableEls[focusableEls.length - 1];

      if (!firstEl) return; // nothing to trap

      // focus the first focusable element
      firstEl.focus();

      const handleKeyDown = (e) => {
        if (e.key === 'Tab') {
          if (e.shiftKey) {
            // shift + tab
            if (document.activeElement === firstEl) {
              e.preventDefault();
              lastEl.focus();
            }
          } else {
            // tab
            if (document.activeElement === lastEl) {
              e.preventDefault();
              firstEl.focus();
            }
          }
        }
        // Escape closes trap (optional)
        // if (e.key === 'Escape') {
        //   container.classList.remove('active');
        //   document.removeEventListener('keydown', handleKeyDown);
        // }
      };

      document.addEventListener('keydown', handleKeyDown);
    }
  }
  if (!customElements.get('main-password')) {
    customElements.define('main-password', MainPassword);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reveal-images"] && !Shopify.designMode) return;
  try {
    
  class StackCards extends HTMLElement {
    constructor() {
      super();

      this.items = [];
      this.scrollingFn = null;
      this.scrolling = false;
      this.marginY = 0;
      this.elementHeight = 0;
      this.cardTop = 0;
      this.cardHeight = 0;
      this.windowHeight = 0;

      this._intersectionObserver = null;
      this._resizeTimeout = null;

      this._onScroll = this._onScroll.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onIntersection = this._onIntersection.bind(this);
      this._onFocusIn = this._onFocusIn.bind(this);
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-stack-slide]'));
      if (this.items.length === 0) return;
      // Respect reduced motion
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // Refined IntersectionObserver
      if ('IntersectionObserver' in window) {
        this._intersectionObserver = new IntersectionObserver(this._onIntersection, {
          root: null,
          rootMargin: '0px 0px -40% 0px', // trigger earlier/later
          threshold: 0.1, // start when 10% is visible
        });
        this._intersectionObserver.observe(this);
      }

      window.addEventListener('resize', this._onResize, { passive: true });
      this.addEventListener('focusin', this._onFocusIn);

      this.Imagestyle = this.getAttribute('data-images-style');

      this._setStackCards();
    }

    disconnectedCallback() {
      if (this._intersectionObserver) {
        this._intersectionObserver.disconnect();
      }
      window.removeEventListener('resize', this._onResize);
      this.removeEventListener('focusin', this._onFocusIn);
      this._removeScrollListener();
    }

    _onIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this._addScrollListener();
          this._animateStackCards(); // run immediately on enter
        } else {
          this._removeScrollListener();
          this.items.forEach((item) => item.classList.remove('is-focused'));
        }
      });
    }

    _addScrollListener() {
      if (!this.scrollingFn) {
        this.scrollingFn = this._onScroll;
        window.addEventListener('scroll', this.scrollingFn, { passive: true });
      }
    }

    _removeScrollListener() {
      if (this.scrollingFn) {
        window.removeEventListener('scroll', this.scrollingFn);
        this.scrollingFn = null;
      }
    }

    _onScroll() {
      if (!this.scrolling) {
        this.scrolling = true;
        window.requestAnimationFrame(() => this._animateStackCards());
      }
    }

    _onResize() {
      clearTimeout(this._resizeTimeout);
      this._resizeTimeout = setTimeout(() => {
        this._setStackCards();
        this._animateStackCards();
      }, 250);
    }

    _setStackCards() {
      let marginYValue = getComputedStyle(this).getPropertyValue('--stack-cards-gap');
      this.marginY = this._parseCssSizeToPx(marginYValue.trim());

      this.elementHeight = this.offsetHeight;

      if (this.items.length > 0) {
        const cardStyle = getComputedStyle(this.items[0]);
        this.cardTop = Math.floor(parseFloat(cardStyle.getPropertyValue('top'))) || 0;
        this.cardHeight = Math.floor(parseFloat(cardStyle.getPropertyValue('height'))) || 0;
      }

      this.windowHeight = window.innerHeight;

      this.style.paddingBottom = isNaN(this.marginY) ? '0px' : `${this.marginY * (this.items.length - 1)}px`;

      this.items.forEach((item, i) => {
        if (!isNaN(this.marginY)) {
          item.style.transform = `translateY(${this.marginY * i}px)`;
        } else {
          item.style.transform = 'none';
        }
        item.classList.remove('is-focused');
      });
    }

    _parseCssSizeToPx(value) {
      if (!value) return NaN;
      if (value.endsWith('px')) return parseInt(value);
      if (value.endsWith('rem') || value.endsWith('em')) return parseFloat(value) * 16;
      return NaN;
    }

    _animateStackCards() {
      if (isNaN(this.marginY)) {
        this.scrolling = false;
        return;
      }

      const top = this.getBoundingClientRect().top;

      // Stop animating if we're out of range
      if (
        this.cardTop -
          top +
          this.windowHeight -
          this.elementHeight -
          this.cardHeight +
          this.marginY +
          this.marginY * this.items.length >
        0
      ) {
        this.scrolling = false;
        return;
      }

      const minScale = 0.6;
      const maxScale = 1;

      this.items.forEach((item, i) => {
        const scrolling = this.cardTop - top - i * (this.cardHeight + this.marginY);
        if (scrolling > 0) {
          let scaling = i === this.items.length - 1 ? maxScale : (this.cardHeight - scrolling * 0.15) / this.cardHeight;

          // Keep scale between min and max
          scaling = Math.max(minScale, Math.min(maxScale, scaling));

          // Also keep Y offset so they appear stacked
          const translateY = this.marginY * i;
          if (this.Imagestyle == 'contain') {
            item.style.transform = `translateY(${translateY}px) scale(${scaling})`;
          } else {
            item.style.transform = `translateY(${translateY}px)`;
          }
        } else {
          item.style.transform = `translateY(${this.marginY * i}px) scale(${maxScale})`;
        }
      });

      this.scrolling = false;
    }
    
    _onFocusIn(event) {
        const focusedItem = event.target.closest('[data-stack-slide]');
        if (!focusedItem) return;

        this.items.forEach((item) => item.classList.remove('is-focused'));
        focusedItem.classList.add('is-focused');

        const get_offsettop = focusedItem.offsetTop;
        const itemRect = focusedItem.getBoundingClientRect();
        const get_height = itemRect.height / 2;
        const i = this.items.indexOf(focusedItem);
          const getnew = get_height + this.marginY * i

          const isLast = focusedItem === this.items[this.items.length - 1];
          const isBackward = event.shiftKey === true;
          
          if (isBackward) {
            // Align focused card like manual scroll: compute delta from current viewport to sticky top
            const containerTop = this.getBoundingClientRect().top; // viewport y for component
            const stickyTop = this.cardTop || 0; // same top used by sticky items
            const targetTopInViewport = focusedItem.getBoundingClientRect().top; // current top of focused card
            const delta = targetTopInViewport - (containerTop + stickyTop);

            // Scroll by the exact delta so focused card lands at sticky anchor
            window.scrollBy({ top: delta, behavior: 'smooth' });

            // After scroll progresses, run the same animation step as manual scrolling
            const handleScrollProgress = () => {
              if (!this.scrolling) {
                this.scrolling = true;
                window.requestAnimationFrame(() => this._animateStackCards());
              }
            };
            window.addEventListener('scroll', handleScrollProgress, { once: true, passive: true });

            // Fallback to ensure animation runs even if no scroll event fires
            setTimeout(() => {
              handleScrollProgress();
            }, 200);
          } else {
            if(isLast){
              window.scrollTo({
                  top: get_offsettop,
                  behavior: 'smooth',
                });
            }else{
              window.scrollTo({
                top: get_offsettop - getnew,
                behavior: 'smooth',
              });
          }
          }
        this._animateStackCards();

      }

  }

  customElements.define('stack-cards', StackCards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reveal-shop"] && !Shopify.designMode) return;
  try {
    

  class SectionIntroAnimation extends HTMLElement {
    constructor() {
      super();
  
      this.holder = this;
      this.container = this.holder.querySelector('[data-section-container]');
      this.introHeader = this.holder.querySelector('[data-intro-header]');
      this.introInner = this.holder.querySelector('[data-scroll-inner]');
      
      this.introFooter = this.holder.querySelector('[data-intro-footer]');
      this.firstImageBlock = this.holder.querySelector('[data-first-image]');
      this.firstImageBlockScale = this.holder.querySelector('[data-intro-image]');
      this.secondImageBlock = this.holder.querySelector('[data-second-image]');
      this.secondImage = this.secondImageBlock?.querySelector('[data-image]');
      this.transitionProgress = { value: 0 };
      this.section = this.closest('section');
      this.pin = this.section.querySelector('[data-section-pin]');
  
      this.stickyOffset = this.section.offsetTop;
  
      this.tl = null;
      this.mediaQuery = window.matchMedia('(min-width: 768px)');
      this.prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  
      if (this.shouldRunAnimations()) {
        this.init();
      }
  
      this.mediaQuery.addEventListener('change', (e) => {
        if (e.matches && this.shouldRunAnimations()) {
          this.init();
        } else {
          this.kill();
        }
      });
  
      this.prefersReduced.addEventListener('change', (e) => {
        if (e.matches) {
          this.kill();
        } else if (this.mediaQuery.matches) {
          this.init();
        }
      });

      const inEditor = typeof Shopify !== 'undefined' && Shopify.designMode;
      if (inEditor) {
        document.addEventListener('shopify:section:load', this.onSectionLoad);
        document.addEventListener('shopify:section:unload', this.onSectionUnload);
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
      }

    }
  
    shouldRunAnimations() {
      return this.mediaQuery.matches && !this.prefersReduced.matches;
    }
  
    init() {
      this.kill();
      this.tl = this.getAnimation();
      if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.refresh) {
        ScrollTrigger.refresh();
      }
    }
  
    kill() {
      if (this.tl) {
        if (this.tl.scrollTrigger) this.tl.scrollTrigger.kill();
        this.tl.kill();
        this.tl = null;
      }
  
      if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.getAll) {
        ScrollTrigger.getAll().forEach((st) => {
          if (st.trigger === this.pin) st.kill();
        });
      }
  
      if (typeof gsap !== 'undefined' && gsap.set) {
        gsap.set(
          [
            this.introHeader,
            this.introFooter,
            this.firstImageBlock,
            this.firstImageBlockScale,
            this.secondImageBlock,
            this.secondImage
          ].filter(Boolean),
          { clearProps: 'all' }
        );
      }
  
      this.section.classList.remove('sticky');
    }
  
    getAnimation() {
      if (typeof gsap === 'undefined') return null;
      if (typeof ScrollTrigger !== 'undefined' && gsap.registerPlugin) {
        gsap.registerPlugin(ScrollTrigger);
      }

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: this.pin,
          start: 'top top',
          end: () => {
            const h = this.pin ? this.pin.scrollHeight : 0;
            return h > 0 ? `+=${h}` : '100%';
          },
          scrub: 2.5,
          pin: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
          pinSpacing: true 
        }
      });
  
      const introHeaderAnim = gsap.fromTo(
        this.introHeader,
        { yPercent: 0 },
        { 
          yPercent: -100,
          duration: 1.5,
          ease: 'none'
         }
      );
  
      // const introInnerAnim = gsap.fromTo(
      //   this.introInner,
      //   { yPercent: 0 },
      //   { yPercent: -120, duration: 1.5, ease: 'none' }
      // );
  
      const introFooterAnim = gsap.fromTo(
        this.introFooter,
        { yPercent: 0 },
        { yPercent: -170, duration: 1.5, ease: 'none' }
      );
  
      gsap.set(this.firstImageBlock, { x: 0 });
  
      const firstImageAnim = gsap.fromTo(
        this.firstImageBlock,
        { x: () => {
            const containerW = this.section.getBoundingClientRect().width || 0;
            const elW = this.firstImageBlock?.getBoundingClientRect().width || containerW;
            return Math.min(containerW, elW) * 0.5; // start half-width to the right
          }
        },
        { x: 0, duration: 4.5, ease: 'none' }
      );
  
      const firstImageBlockScaleAnmi = gsap.fromTo(
        this.firstImageBlockScale,
        { scale: 1 },
        { scale: 0.8, duration: 4.5, ease: 'none' }
      );
  
      const secondImageBlockAnim = this.secondImageBlock
        ? gsap.fromTo(
            this.secondImageBlock,
            {
              x: () => {
                const containerW = this.section.getBoundingClientRect().width || 0;
                const elW = this.secondImageBlock?.getBoundingClientRect().width || containerW;
                return Math.min(containerW, elW) * 0.5;
              },
              scale: 0.8
            },
            { x: 0, scale: 1, duration: 4.5, ease: 'none' }
          )
        : null;
  
      const secondImageAnim = this.secondImage
        ? gsap.fromTo(
            this.secondImage,
            { x: () => {
                const containerW = this.section.getBoundingClientRect().width || 0;
                const elW = this.secondImage?.getBoundingClientRect().width || containerW;
                return Math.min(containerW, elW) * 0.5;
              }
            },
            { x: 0, duration: 4.5, ease: 'none' }
          )
        : null;
  
      tl.add(introHeaderAnim)
        .add(introFooterAnim,'<')
        .add(firstImageAnim, '<')
        .add(firstImageBlockScaleAnmi, '<');
  
      if (secondImageBlockAnim) tl.add(secondImageBlockAnim, '<');
      if (secondImageAnim) tl.add(secondImageAnim, '<');
  
      return tl;
    }

    onSectionLoad = (event) => {
      if (!event.target.contains(this)) return;
      requestAnimationFrame(() => {
        if (this.shouldRunAnimations()) {
          this.init();
          if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.refresh) ScrollTrigger.refresh();
        } else {
          this.kill();
        }
      });
    };

    onSectionUnload = (event) => {
      if (!event.target.contains(this)) return;
      this.kill();
    };

    onSectionSelect = (event) => {
      if (!event.target.contains(this)) return;
      requestAnimationFrame(() => {
        if (this.shouldRunAnimations()) {
          this.init();
          if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.refresh) ScrollTrigger.refresh();
        }
      });
    };

    onSectionDeselect = (event) => {
      if (!event.target.contains(this)) return;
      this.kill();
    };
  
    createRevealTimeline(container, target, section) {
      const { width } = section.getBoundingClientRect();
      const tl = gsap.timeline();
  
      const pointerEventsOff = gsap.fromTo(target, { pointerEvents: 'all' }, { pointerEvents: 'all', duration: 1 });
  
      const clipExpand = gsap.fromTo(
        container,
        { '--corner-clip': 0 },
        {
          '--corner-clip': `${1.5 * width}px`,
          duration: 1.5,
          ease: 'none',
          onUpdate: () => {
            const value = parseFloat(gsap.getProperty(container, '--corner-clip'));
            if (container.querySelector('[data-collections-list]')) {
              const productList = container.querySelector('[data-collections-list]');
              if (value > 50) productList.classList.add('revealed');
              else productList.classList.remove('revealed');
            }
          }
        }
      );
  
      const translateX = gsap.fromTo(
        container,
        { '--corner-clip-x': 100, '--xpx': '0px' },
        { '--corner-clip-x': 0, '--xpx': `${width}px`, duration: 1.5 }
      );
  
      return tl.add(pointerEventsOff).add(clipExpand, '<').add(translateX);
    }
  }
  customElements.define('xs-reveal-shop', SectionIntroAnimation);

  // Observe content size changes inside pinned section to refresh ScrollTrigger
  (function(){
    try {
      const el = document.querySelector('xs-reveal-shop');
      if (!el || typeof ResizeObserver === 'undefined' || typeof ScrollTrigger === 'undefined') return;
      const ro = new ResizeObserver(() => {
        if (ScrollTrigger && ScrollTrigger.refresh) ScrollTrigger.refresh();
      });
      ro.observe(el);
    } catch (e) {}
  })();
  
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  class TimelineSection extends HTMLElement {
    constructor() {
      super();
      this.buttons = [];
      this.contents = [];
      this.images = [];
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('[data-timeline-button]');
      this.contents = this.querySelectorAll('[data-timeline-content]');
      this.images = this.querySelectorAll('[data-media]');

      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => this.switchTab(btn.dataset.tab));
      });
    }

    switchTab(tabId) {
      // Remove active state from all
      this.buttons.forEach((b) => b.classList.remove('active'));
      this.contents.forEach((c) => c.classList.add('hidden'));
      this.images.forEach((img) => img.classList.add('hidden'));

      // Activate clicked tab
      const activeBtn = this.querySelector(`[data-tab="${tabId}"]`);
      const activeContent = this.querySelector(`#${tabId}`);
      const activeImage = this.querySelector(`[data-media="${tabId}"]`);

      if (activeBtn) activeBtn.classList.add('active');
      if (activeContent) activeContent.classList.remove('hidden');
      if (activeImage) activeImage.classList.remove('hidden');
    }
  }

  customElements.define('timeline-section', TimelineSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-overlay-text"] && !Shopify.designMode) return;
  try {
    
  class AnimatedCursor extends HTMLElement {
    constructor() {
      super();

      this.mouse = { x: -100, y: -100 };
      this.pos = { x: 0, y: 0 };
      this.speed = 0.15;
      this.element = null;

      this.updateCoordinates = this.updateCoordinates.bind(this);
      this.addCursorClass = this.addCursorClass.bind(this);
      this.removeCursorClass = this.removeCursorClass.bind(this);
      this.removeCursor = this.removeCursor.bind(this);
      this.startDrag = this.startDrag.bind(this);
      this.endDrag = this.endDrag.bind(this);

      this.cursorScope = this.closest('.shopify-section');
      if (!this.cursorScope) return;

      // ✅ Media query watcher (mobile breakpoint)
      this.mq = window.matchMedia('(max-width: 767px)');
      this.mq.addEventListener('change', this.handleBreakpointChange.bind(this));

      // Run once on init
      this.handleBreakpointChange(this.mq);
    }

    handleBreakpointChange(e) {
      const section = this.closest('.shopify-section');
      const video = section?.querySelector('video');

      if (e.matches) {
        // ✅ Mobile
        this.disableCursor();
      } else {
        // ✅ Desktop
        this.enableCursor();
      }
    }

    enableCursor() {
      if (this.enabled) return; // already active
      this.enabled = true;
      this.style.display = 'block';

      this.cursorScope.querySelectorAll('[cursor-class]').forEach((el) => {
        el.addEventListener('pointerenter', this.addCursorClass);
        el.addEventListener('pointerleave', this.removeCursorClass);
        el.addEventListener('mouseleave', this.removeCursorClass);
        el.addEventListener('mouseout', this.removeCursor);
        el.addEventListener('mousedown', this.startDrag);
        el.addEventListener('mouseup', this.endDrag);
      });

      this.cursorScope.addEventListener('pointermove', this.updateCoordinates);

      this.wasInsideOnLastWheel = false;
      this._wheelHandler = this.handleWheel.bind(this);
      window.addEventListener('wheel', this._wheelHandler, { passive: true });

      if (!this._observer) {
        this._observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.style.display = 'block';
              } else {
                this.style.display = 'none';
                this.mouse = { x: -100, y: -100 };
              }
            });
          },
          { threshold: 0 }
        );
        this._observer.observe(this.cursorScope);
      }

      this._raf = requestAnimationFrame(this.loop.bind(this));
    }

    disableCursor() {
      if (!this.enabled) return;
      this.enabled = false;
      this.style.display = 'none';

      this.cursorScope.querySelectorAll('[cursor-class]').forEach((el) => {
        el.removeEventListener('pointerenter', this.addCursorClass);
        el.removeEventListener('pointerleave', this.removeCursorClass);
        el.removeEventListener('mouseleave', this.removeCursorClass);
        el.removeEventListener('mouseout', this.removeCursor);
        el.removeEventListener('mousedown', this.startDrag);
        el.removeEventListener('mouseup', this.endDrag);
      });

      this.cursorScope.removeEventListener('pointermove', this.updateCoordinates);
      window.removeEventListener('wheel', this._wheelHandler);

      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }

      cancelAnimationFrame(this._raf);
    }

    handleWheel(e) {
      const cursorScope = this.closest('video-media');
      if (!cursorScope) return;

      const rect = cursorScope.getBoundingClientRect();

      // Check if mouse position is inside section
      const inside =
        this.mouse.x >= rect.left &&
        this.mouse.x <= rect.right &&
        this.mouse.y >= rect.top &&
        this.mouse.y <= rect.bottom;

      if (inside && !this.wasInsideOnLastWheel) {
        this.classList.add('floating-play');
      } else if (!inside && this.wasInsideOnLastWheel) {
        this.classList.remove('floating-play');
      }

      this.wasInsideOnLastWheel = inside;
    }

    handleScroll() {
      const hoveredEl = document.elementFromPoint(this.mouse.x, this.mouse.y);
      if (!hoveredEl) return;

      const newTarget = hoveredEl.closest('[cursor-class]');
      if (newTarget !== this.element) {
        if (this.element) this.removeCursorClass({ currentTarget: this.element });
        if (newTarget) this.addCursorClass({ currentTarget: newTarget });
        this.element = newTarget;
      }
    }

    updateCoordinates(e) {
      this.mouse.x = e.clientX;
      this.mouse.y = e.clientY;
    }

    startDrag(e) {
      this.updateCoordinates(e);
    }

    endDrag(e) {
      this.updateCoordinates(e);
    }

    removeCursor() {
      this.element = null; // reset when leaving
    }

    addCursorClass(e) {
      this.element = e.currentTarget;
      const className = this.element.getAttribute('cursor-class');
      if (className === 'video') {
        this.classList.add('floating-play');
      }
    }

    removeCursorClass(e) {
      const className = e.currentTarget.getAttribute('cursor-class');
      if (className === 'video') {
        this.classList.remove('floating-play');
      }
    }

    getAngle(dx, dy) {
      return (Math.atan2(dy, dx) * 180) / Math.PI;
    }

    getSqueeze(dx, dy) {
      const distance = Math.sqrt(dx * dx + dy * dy);
      const maxSqueeze = 0.0;
      const accelerator = 1500;
      return Math.min(distance / accelerator, maxSqueeze);
    }

    updateCursor() {
      const dx = this.mouse.x - this.pos.x;
      const dy = this.mouse.y - this.pos.y;

      this.pos.x += dx * this.speed;
      this.pos.y += dy * this.speed;

      const angle = this.getAngle(dx, dy);
      const squeeze = this.getSqueeze(dx, dy);

      this.style.translate = `${this.pos.x}px ${this.pos.y}px`;
      // this.style.transform = `scale(${2 + squeeze}, ${2 - squeeze}) rotate(${angle}deg)`;
    }

    loop() {
      if (!this.enabled) return; // stop loop when disabled
      this.updateCursor();
      this._raf = requestAnimationFrame(this.loop.bind(this));
    }
  }

  customElements.define('animated-cursor', AnimatedCursor);

  } catch(e) { console.error(e); }
})();
})();
